import { fireBIEvent } from 'public/bi-events.js';
import { url as PageURL } from 'wix-location';
import { getUserDetails } from 'backend/wixUsers.jsw';
import { memory } from 'wix-storage';
import { formFactor, openLightbox } from 'wix-window';

let savedUserEmail;
let userFormFactor = formFactor;

////////////////////////////////////////////////////////////////////

$w.onReady(function () {
	showBanner();
});

////////////////////////////////////////////////////////////////////

export function LogInCNT_click() {
	const biFields = {
        button_name: 'Log_In',
		topic: 'Click on the "Log In" button in the header',
        url: PageURL
	}
	fireBIEvent(19, 703, biFields);
}

export function LogInCNTMobile_click(event) {
	const biFields = {
        button_name: 'Blog_Mobile_Menu_Login',
		topic: 'Click on the Banner in a Blog Post page.',
        url: PageURL
	    }
	fireBIEvent(19, 703, biFields);
}

export function SubscribeCNT_click() {
	const biFields = {
        button_name: 'Subscribe',
		topic: 'Click on the "Subscribe" button in the header.',
        url: PageURL
	}
	fireBIEvent(19, 703, biFields);
}

export function SubscribeCNTMobile_click(event) {
	const biFields = {
        button_name: 'Blog_Mobile_Menu_Subscribe',
		topic: 'Click on the Banner in a Blog Post page.',
        url: PageURL
	    }
	fireBIEvent(19, 703, biFields);
}

export function CreateYourStoreCNT_click() {
	const biFields = {
        button_name: 'Signup',
		topic: 'Click on the "Create Your Store" button in the header.',
        url: PageURL
	}
	fireBIEvent(19, 703, biFields);
}

export function CreateYourStoreCNTMobile_click(event) {
	const biFields = {
        button_name: 'Blog_Mobile_Menu_Signup',
		topic: 'Click on the Banner in a Blog Post page.',
        url: PageURL
	    }
	fireBIEvent(19, 703, biFields);
}

export function mobileBox1_click(event) {
	const biFields = {
        button_name: 'Blog_Mobile_Header_Signup',
		topic: 'Click on the Banner in a Blog Post page.',
        url: PageURL
	    }
	fireBIEvent(19, 703, biFields);
}

export function JoinCNT_click(event) {
	const biFields = {
        button_name: 'Blog_Subscriptin_Fold',
		topic: 'Click on the Banner in a Blog Post page.',
        url: PageURL
	    }
	fireBIEvent(19, 703, biFields);
}

export function JoinCNTMobile_click(event) {
	const biFields = {
        button_name: 'Blog_Subscriptin_Fold_Mobile',
		topic: 'Click on the Banner in a Blog Post page.',
        url: PageURL
	    }
	fireBIEvent(19, 703, biFields);
}

////////////////////////////////////////////////////////////////////

function showBanner() {
    // CHECK IF IT'S A USER
    getUserDetails().then(user => {
            savedUserEmail = user.email;
        })
        .catch((err) => {
            console.log("showBannerERR")

            let boolUserSawBannner = memory.getItem("userSawBanner"); // "value"
            setTimeout(function () {
                if (boolUserSawBannner === null) {
                    memory.setItem("userSawBanner", "true");
                    if (userFormFactor !== "Mobile") {
                        openLightbox("Banner");
                    }
                }
            }, 3000);
            let errMsg = err.message;
            let errCode = err.code;
        });
}